export default {
  SUBURB_REPOSITORY: Symbol.for('SUBURB_REPOSITORY'),
  GET_SUBURBS_IN_ZIP_CODE_QUERY: Symbol.for('GET_SUBURBS_IN_ZIP_CODE_QUERY'),
  SUBURBS_IN_ZIP_CODE_STATE_MANAGER: Symbol.for('SUBURBS_IN_ZIP_CODE_STATE_MANAGER'),
};
